import { Suspense } from "react";
import { useAtomValue } from "jotai";
import { Icon, Link } from "@zapier/design-system";
import { Tooltip } from "@zapier/design-system-beta";
import { isZapPublishedAsyncAtomFamily } from "@zapier/canvas-state";
import styles from "./ZapLink.module.css";
import { buildEditorLink } from "../../utils/buildEditorLink";

type Props = { zapId: string; onClick: () => void };

function SuspendedZapLink({ zapId, onClick }: Props) {
  const isPublished = useAtomValue(isZapPublishedAsyncAtomFamily(zapId));

  // This means the zap is not found or a zsl template zap
  if (isPublished === null) {
    return null;
  }

  const editorLink = buildEditorLink(zapId, isPublished);

  return (
    <Tooltip placement="top" content="Open Zap">
      <Tooltip.FocusableTrigger>
        <Link
          href={editorLink}
          className={styles.linkWrapper}
          target="_blank"
          onClick={onClick}
        >
          <Icon name="arrowOffsite" size={20} color="GrayWarm5" />
        </Link>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}

export function ZapLink({ zapId, onClick }: Props) {
  return (
    <Suspense fallback={null}>
      <SuspendedZapLink zapId={zapId} onClick={onClick} />
    </Suspense>
  );
}
